import type { WorkflowFilterStatus } from '@app/shared/types/sf-data'

import { defineStore } from 'pinia'
import { ref } from 'vue'

import { getOverviewFilter } from '@app/adapters/silverfin'
import { userApi } from '@app/shared/api'

export const useWorkflowReviewFilter = defineStore(
  'workflow-review-filter',
  () => {
    // Each time the filter is initialized from the interpolated backend data
    // The Vue components will only deal with the filter as a ref using this store as the source of truth
    const filter = ref(getOverviewFilter())

    async function applyFilter(newFilter: WorkflowFilterStatus): Promise<void> {
      filter.value = newFilter

      await userApi.persistOverviewFilter(newFilter)
    }

    return {
      applyFilter,
      filter,
    }
  }
)
